import type { ManagerProfile } from "@averagejoesff/shared";

interface ManagerPickerProps {
  profiles: readonly ManagerProfile[];
  onPick: (personId: string) => void;
  /** For visitors who aren't in the league. */
  onSpectate: () => void;
}

/**
 * "Which manager are you?" — one button per current manager, and one for
 * anyone who isn't a manager. Former managers aren't offered (nobody visiting
 * is one); their profiles still have a "This is me" button, and a pick made
 * earlier is still honored.
 */
export function ManagerPicker({ profiles, onPick, onSpectate }: ManagerPickerProps) {
  const ordered = profiles.filter((p) => p.active).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <section className="home-picker" aria-labelledby="home-picker-heading">
      <h3 id="home-picker-heading" className="home-picker__title">
        Who are you?
      </h3>
      <p className="home-picker__hint">Pick your name and this page opens on your team, or just have a look around. It's remembered on this device only.</p>
      <ul className="home-picker__list">
        {ordered.map((profile) => (
          <li key={profile.personId}>
            <button type="button" className="home-picker__option" onClick={() => onPick(profile.personId)}>
              {profile.name}
            </button>
          </li>
        ))}
        <li>
          <button type="button" className="home-picker__option home-picker__option--secondary" onClick={onSpectate}>
            I'm just watching
          </button>
        </li>
      </ul>
    </section>
  );
}
